import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import {
  BUSINESS_REGISTRATION_UNAVAILABLE_PATH,
  isBusinessRegistrationBlockedRole,
} from '../utils/businessRegistrationAccess';

const BusinessRegistrationRouteGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && isBusinessRegistrationBlockedRole(user?.role)) {
    return (
      <Navigate
        to={BUSINESS_REGISTRATION_UNAVAILABLE_PATH}
        replace
        state={{ blockedRole: user?.role }}
      />
    );
  }

  return children;
};

export default BusinessRegistrationRouteGuard;
